/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

export type AnalyticsAttributes = Record<string, string | number | boolean>;

type Aptrinsic = (command: 'track', event: string, attributes: AnalyticsAttributes) => void;

/**
 * Sends a custom Gainsight event, only when the Gainsight script is on the page. Attributes must never carry customer
 * data (repository, component or user names, URLs, comments).
 */
export function trackAnalyticsEvent(event: string, attributes: AnalyticsAttributes = {}): void {
  const aptrinsic = (window as unknown as { aptrinsic?: Aptrinsic }).aptrinsic;
  if (typeof aptrinsic !== 'function') {
    return;
  }
  try {
    aptrinsic('track', event, attributes);
  } catch {
    // analytics must never break the page
  }
}
